import PageHeader from "@/components/PageHeader";
import healthImg from '../assets/health.jpg';
import childImg from '../assets/child-protection.jpg';
import coordImg from '../assets/coordination.jpg';
import cashImg from '../assets/cash.jpg';
import climateImg from '../assets/climate.jpg';
import livestockImg from '../assets/livestock.jpg';
import inclusionImg from '../assets/inclusion.jpg';

const programs = [
  { img: healthImg, t: "Health & Nutrition Services", d: "CRDO provides maternal, infant, and child health services, addressing the needs of pregnant and lactating women, malnourished infants, and children under five. It has extensive experience in implementing Maternal, Infant, and Young Child Nutrition (MIYCN) programs and promoting food security initiatives that focus on the well-being of vulnerable households." },
  { img: childImg, t: "Child Protection & Advocacy", d: "CRDO works to ensure children's rights are upheld through structured child protection programs. It collaborates with community leaders, local governments, and civil society organizations to establish safe environments where children can thrive." },
  { img: coordImg, t: "Multisectoral Peacebuilding and Social Cohesion", d: "CRDO effectively integrates interventions across multiple sectors, including health, nutrition, water and sanitation, education, and livelihoods, ensuring comprehensive support for communities. The organization has extensive experience coordinating aid efforts in Internally Displaced Persons (IDP) camps and host communities." },
  { img: cashImg, t: "Multipurpose Cash Assistance", d: "CRDO strategically implements cash transfer programs that address the immediate needs of vulnerable households. These programs support individuals who have lost livelihoods, including people with disabilities, pregnant and lactating women, and the elderly." },
  { img: climateImg, t: "Climate Change Mitigation & Adaptation", d: "CRDO leads initiatives focused on environmental conservation, sustainable land management, and climate-smart agricultural practices. These efforts include afforestation programs, the promotion of renewable energy solutions, and educational campaigns on climate resilience." },
  { img: livestockImg, t: "Livestock Resilience & Market Access", d: "CRDO supports pastoralist communities by enhancing livestock productivity through veterinary services, disease control programs, and improved rangeland management. Additionally, CRDO works to strengthen cross-border livestock trade, improving economic opportunities for rural communities." },
  { img: inclusionImg, t: "Disability & Social Inclusion", d: "CRDO ensures that marginalized groups, including persons with disabilities, have equal access to services and opportunities. Through targeted programs, the organization works to remove barriers to inclusion in education, employment, and healthcare." },
];

const Programs = () => (
  <>
    <PageHeader
      eyebrow="Programs"
      title="Integrated programs that meet today's needs and tomorrow's challenges."
      subtitle="From lifesaving health services to long-term climate adaptation, our program areas are designed to work together — not in silos."
    />

    <section className="section-padding">
      <div className="container-wide space-y-20">
        {programs.map((p, i) => (
          <article
            key={p.t}
            className={`grid gap-10 md:grid-cols-2 md:items-center ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}
          >
            <div className="overflow-hidden rounded-lg shadow-[var(--shadow-elegant)]">
              <img
                src={p.img}
                alt={p.t}
                loading="lazy"
                width={1024}
                height={768}
                className="aspect-[4/3] h-full w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div>
              <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-primary md:text-4xl">
                {p.t}
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-muted-foreground">{p.d}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  </>
);

export default Programs;
